/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class PhotoTextureLoaderEvent extends alm.event.Event {

		public static COMPLETE:string = "PhotoTextureLoaderEvent.COMPLETE";
		public static PROGRESS:string = "PhotoTextureLoaderEvent.PROGRESS";
		public static ERROR:string = "PhotoTextureLoaderEvent.ERROR";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, texture:THREE.Texture, progressEvent:ProgressEvent, errorEvent:ErrorEvent) {
			super(eventType, target);
			this.texture = texture;
			this.progressEvent = progressEvent;
			this.errorEvent = errorEvent;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getTexture():THREE.Texture {
			return this.texture;
		}

		public getProgressEvent():ProgressEvent {
			return this.progressEvent;
		}

		public getErrorEvent():ErrorEvent {
			return this.errorEvent;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private texture:THREE.Texture;
		private progressEvent:ProgressEvent;
		private errorEvent:ErrorEvent;
	}
}
